<template>
  <div id="single-product-page">
    <ActiveProduct />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import ActiveProduct from "@/components/Projects/Project/ActiveProduct/ActiveProduct.vue";

export default {
  name: "SingleProduct",

  computed: {
    ...mapState("project", ["activeProduct", "editableProduct"]),
    ...mapState("threekit", ["cachedTKData"]),
    ...mapGetters("project", ["is3DAvailable"]),
    ...mapGetters("showroom", ["dealerCode"]),

    product() {
      //Regla para mostrar el editable o el active, pero por ahora lo desactivamos porque no hay chance de darle 'cancel'
      // return this.showEditableProduct
      //   ? this.editableProduct
      //   : this.activeProduct;
      return this.activeProduct;
    },

    gender() {
      return this.product.gender.toLowerCase();
    },

    inheritedDesign() {
      return this.product.designs_by_gender[this.gender];
    },

    priceText() {
      return `$${this.product.price} per piece`;
    },

    leadText() {
      return `${this.product.production_time} Business Days Lead Time`;
    },
  },

  methods: {
    ...mapActions("threekit", ["initPlayerConfigurator", "close3DDecorations"]),
    ...mapActions("showroom", ["checkEmptyCatalogs", "setBreadcrumbs"]),
  },

  async mounted() {
    //todo check required fields

    this.checkEmptyCatalogs();
    this.setBreadcrumbs([
      {
        name: "< BACK TO BROWSING",
        url: `/showrooms/${this.dealerCode}/catalogue`,
      },
    ]);

    //Call for the 3d player
    /*  if (this.is3DAvailable) {

      console.log('init 3d using: ', {
        styleName: this.activeProduct.styleName,
        designName: this.activeProduct.designName,
      })

      await this.initPlayerConfigurator({
        styleName: this.activeProduct.styleName,
        designName: this.activeProduct.designName,
        /*designName: "Brush",
        styleName: "J180A",
      });
    }*/
  },

  components: {
    ActiveProduct,
  },
};
</script>

<style lang="scss">
#app {
  #single-product-page {
    .editable-product-wrapper {
      position: relative;
      max-width: 1440px;
      margin: 0 auto;
    }
    .editable-product {
      height: 90vh;
      max-height: 733px;
      display: flex;
      flex-direction: column;
      background: white;
      border-radius: 3px;

      .editable-product-header {
        height: 16%;
        border-bottom: 1px solid $borderColor;

        .editable-product-header-top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 1.5rem;
        }

        #editable-product-steps {
          display: flex;
          padding: 0.5rem 1.5rem;
          padding-top: 0;
          .navigation-item {
            display: flex;
            align-items: center;
            width: 25%;
            cursor: pointer;
            transition: text-decoration 0.2s;
            &:hover {
              text-decoration: underline;
            }
            .navigation-label {
              transition: text-decoration 0.2s;
              text-transform: uppercase;
            }
            .navigation-check {
              width: 21px;
              height: 21px;
              border-radius: 50%;
              border: 2px solid rgba(236, 237, 237, 1);
              margin-right: 0.75rem;
              display: flex;
              align-items: center;
              justify-content: center;
              &.checked {
                background: $dark;
                border: 2px solid transparent;
              }
              .checkmark {
                /* display: inline-block; */
                transform: rotate(45deg);
                height: 9px;
                width: 4px;
                margin-bottom: 2px;
                margin-left: 1px;
                border-bottom: 1px solid white;
                border-right: 1px solid white;
              }
            }

            .dash {
              border: 1px solid #eceded;
              width: 1.5rem;
              margin: 0 auto;
            }
          }
        }
      }

      .editable-product-content {
        display: flex;
        height: 84%;

        ::v-deep .editable-product-menu-container {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: 50%;
          height: 100%;

          .component-wrapper {
            overflow-y: auto;
            padding: 2rem 1rem 1rem 2.5rem;
            display: flex;
            flex-grow: 1;
          }

          .footer-container {
            width: 100%;
            padding: 1rem;
            background: white;
            box-shadow: 0px -4px 20px 0px rgba(215, 216, 219, 0.5);
            border-top: 1px solid #d7d8db;
            position: sticky;
            bottom: 0;
            #navigation-buttons {
              display: flex;
              justify-content: space-between;
              .btn {
                background: black;
                color: white;
              }
              .btn-transparent {
                background: transparent;
                color: $grey-dark;
                display: flex;
                align-items: center;
                img {
                  width: 18px;
                  margin-top: 1px;
                  margin-right: 3px;
                }
              }
            }
          }
        }
        .product-preview-wrapper {
          display: flex;
          flex-direction: column;
          width: 50%;
          height: 100%;

          .editable-product-preview {
            background: $grey-lightest;
            padding: 2rem;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;

            #threekit-player {
              width: 100%;
              height: 100%;
            }
            ::v-deep svg {
              width: 100%;
            }
          }

          .product-information {
            > label {
              font-weight: 500;
              font-size: 24px;
              line-height: 130%;
              color: #26262c;
              padding: 8px 50px 8px 20px;
            }
            .product-information-price-lead {
              display: flex;
              flex-direction: column;
              background: #f9fafa;
              border-radius: 6px;
              padding: 8px 50px 8px 20px;
            }

            .product-description {
              padding: 8px 50px 8px 20px;
            }
          }
        }
      }
    }
  }
}
</style>
